import { render } from "./loginforapproval.vue?vue&type=template&id=26aaac04"
import script from "./loginforapproval.js?vue&type=script&lang=js"
export * from "./loginforapproval.js?vue&type=script&lang=js"

import "./loginforapproval.vue?vue&type=style&index=0&id=26aaac04&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__